import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SuggestFeedbackComponent } from './suggest-feedback.component';
import { DirectivesModule } from 'app/directives/directives.module';
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [SuggestFeedbackComponent],
  exports: [SuggestFeedbackComponent],
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    NgbModalModule,
    NgbTooltipModule
  ],
  providers: []
})
export class SuggestFeedbackModule {}
